import { Component, inject, OnInit } from '@angular/core';
import { NsideIdentityService } from '../../shared/services/auth/nSideIdentityService';

@Component({
  selector: 'logout',
  standalone: true,
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css'
})
export class LogoutComponent implements OnInit {
  private authSerivce: NsideIdentityService = inject(NsideIdentityService);

  constructor() {}

  ngOnInit(): void {
    this.authSerivce.logout();
  }

}
